import React, { useState, useEffect } from "react";
import { axiosInstance, fileInstance } from "../axiosConfig";
import { ReactComponent as CancelIcon } from "../assets/cancel.svg";

import {
  FilledButton,
  VerticalGap,
  PopUpLayout,
  PopUpBackground,
  PopUpBox,
  PopUpCancelButton,
} from "../component";

const UploadScreen = ({ projectId, setClose, writer, fileNum, workDate }) => {
  const [file, setFile] = useState(null);
  const [fileWriter, setFileWriter] = useState(writer);
  const [fileMemo, setFileMemo] = useState("");

  const [fileId, setFileId] = useState(0);

  const onFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const onFileUpload = async () => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("writer", fileWriter);
    formData.append("memo", fileMemo);

    try {
      fileInstance
        .post(`${process.env.REACT_APP_BASE_URL}/file/upload`, formData, {
          headers: {
            Authorization: `${localStorage.getItem("accessToken")}`,
          },
        })
        .then((res) => {
          axiosInstance.post(
            `${process.env.REACT_APP_BASE_URL}/file/update`,
            {
              projectId: projectId,
              fileId: res.data.fileId,
              fileNum: fileNum,
              workDate: workDate + "-01",
            },
            {
              headers: {
                Authorization: `${localStorage.getItem("accessToken")}`,
              },
            }
          );
        });

      alert("파일 업로드에 성공했습니다");
      window.location.reload();
    } catch (error) {
      console.error("Error uploading file:", error);
      alert("File upload failed");
      setClose(0);
    }
  };

  return (
    <PopUpBackground>
      <PopUpBox>
        <PopUpCancelButton
          onClick={() => {
            setClose(0);
          }}
        >
          <CancelIcon style={{ width: "100%" }} />
        </PopUpCancelButton>
        <PopUpLayout>
          <input type="file" accept="application/pdf" onChange={onFileChange} />
          <VerticalGap height="30px" />
          <textarea
            type="text"
            placeholder="메모"
            style={{ width: "80%", height: "100px" }}
            value={fileMemo}
            onChange={(e) => setFileMemo(e.target.value)}
          />
          <VerticalGap height="20px" />
          <FilledButton onClick={onFileUpload} style={{ width: "50%" }}>
            업로드
          </FilledButton>
        </PopUpLayout>
      </PopUpBox>
    </PopUpBackground>
  );
};

export default UploadScreen;
